import React, {memo, useState} from 'react';
import {useStorageImageUrl} from '../../hooks/api/useStorageImageUrl';
import {InitialsAvatar} from './InitialsAvatar';
import {Palette} from 'hubbl-shared';

interface AvatarStorageRefProps {
  imageRef: string | undefined;
  name?: string;
  size?: number;
}

export const AvatarStorageRef = memo(
  ({imageRef, name = '', size = 40}: AvatarStorageRefProps) => {
    const imageUrl = useStorageImageUrl(imageRef);
    const [imageError, setImageError] = useState(false);

    if (!imageUrl || imageError) {
      return <InitialsAvatar name={name} size={size} fontSize={14} />;
    }

    return (
      <img
        width={size}
        height={size}
        style={{objectFit: 'cover', borderRadius: 50}}
        src={imageUrl}
        alt="profile avatar"
        onError={() => setImageError(true)}
      />
    );
  },
);
